import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Typography,
  IconButton
} from "@mui/material";
import logo from '../../styles/logo.png';

function RegistrationSuccess() {
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex" ,height: "100vh" }}>
    <div style={{ flex: 1, backgroundColor: 'rgba(232, 222, 248, 1)', color: 'white' }}>
				
          <div style={{paddingTop: "250px", paddingLeft: "250px"}}>
            <div style={{ flex: 1, backgroundColor: 'transparent', display: "flex", flexDirection: "column", color: "black", height: '500px', width: '500px',alignItems: "left", }}>
                <div style={{ backgroundImage: `url(${logo})`, backgroundSize: 'contain', backgroundPosition: 'left center', backgroundRepeat: 'no-repeat', height: '250px', width: '250px',  display: "flex"}}></div>
                  <h1 id="blueHeading" style={{  fontFamily: 'Righteous', fontSize: '45px',fontWeight: 900, textAlign: 'left', width: '404px',height:'64px' ,marginBottom: '10px'}}>Resourcing-Bot</h1>
                  <p id="blueText" style={{ fontFamily: 'Source Sans Pro', fontSize: '30px', fontWeight: 500, textAlign: 'left' ,width: '404px',height:'100px',marginTop: '10px'  }}>Your one-stop solution for effortless hiring</p>
                <div>
        
            </div>
        </div>
          <style>
            {`
              #blueHeading {
                animation: zoomIn 3s ease-in-out;
                transform-origin: left center; 
              }
              #blueText {
                animation: zoomIn 3s ease-in-out;
                transform-origin: right center;
              }
              @keyframes zoomIn {
                from {
                  opacity: 0;
                  transform: scale(0); 
                }
                to {
                  opacity: 1;
                  transform: scale(1); 
                }
              }
            `}
          </style>
        </div>
      </div>

      <div style={{ flex: 1, backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", marginRight: '10px', position: "relative" }}>
        <div style={{ padding: "20px", color: "black", width: "500px", marginTop: '100px' }}>
          <Typography style={{ color: "black" }}>
          <IconButton onClick={() => navigate("/")} style={{ color: "black" }}>
          <ArrowBackIcon   style={{ fontSize: "50px" }}/>
        </IconButton>
            <h1>Registration Success</h1>
          </Typography>
          <Typography style={{ color: "black" }}>
            <p>You have successfully registered with us. You will receive an email shortly once your membership is approved.</p>
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default RegistrationSuccess;